const API = process.env.REACT_APP_BACKEND_URL;

export const printInvoice = (bill) => {
  const win = window.open('', '_blank', 'width=800,height=900');
  if (!win) return;
  const itemsHtml = (bill.items || []).map(item => `<tr><td>${item.name}</td><td style="text-align:center">${item.quantity}</td><td style="text-align:right">${item.selling_price}</td><td style="text-align:right">${(item.selling_price * item.quantity).toFixed(2)}</td></tr>`).join('');
  const bt = bill.billed_to || {};
  win.document.write(`<html><head><title>Invoice ${bill.invoice_number}</title>
    <style>
      body{font-family:Arial,sans-serif;padding:24px;color:#111}
      table{width:100%;border-collapse:collapse;margin-top:12px}
      th,td{border:1px solid #ccc;padding:6px;font-size:13px}
      th{background:#f3f4f6;text-align:left}
      .header{display:flex;align-items:center;gap:12px;border-bottom:2px solid #111;padding-bottom:10px}
      .header img{width:56px;height:56px;object-fit:contain}
      .totals{margin-top:12px;width:280px;margin-left:auto}
      .totals div{display:flex;justify-content:space-between;padding:2px 0}
      .grand{font-weight:bold;font-size:16px;border-top:1px solid #111;margin-top:4px}
      .section{margin-top:8px;font-size:13px}
    </style></head>
    <body>
      <div class="header">
        ${bill.vendor_logo ? `<img src="${API}${bill.vendor_logo}" />` : ''}
        <div>
          <h2 style="margin:0">${bill.vendor_name || ''}</h2>
          <div>${bill.vendor_address || ''}</div>
          <div>GSTIN: ${bill.vendor_gst || '-'} | Ph: ${bill.vendor_phone || ''}</div>
        </div>
      </div>
      <h3>Invoice: ${bill.invoice_number}</h3>
      <div class="section">Date: ${new Date(bill.created_at).toLocaleString()}</div>
      <div class="section"><strong>Bill To:</strong> ${bill.patient_name || ''} ${bill.patient_phone ? '| ' + bill.patient_phone : ''}</div>
      <div class="section">
        ${bt.clinic_name ? `<div>${bt.clinic_name}</div>` : ''}
        ${bt.gst_number ? `<div>GSTIN: ${bt.gst_number}</div>` : ''}
        ${bt.email ? `<div>Email: ${bt.email}</div>` : ''}
        ${bt.address ? `<div>Billing Address: ${bt.address}</div>` : ''}
        ${bt.shipping_address ? `<div>Shipping Address: ${bt.shipping_address}</div>` : ''}
      </div>
      ${(bill.num_cartons > 0 || bill.delivery_mode) ? `<div class="section">${bill.num_cartons > 0 ? `Cartons: ${bill.num_cartons} ` : ''}${bill.delivery_mode ? `| Delivery: ${bill.delivery_mode.replace('_', ' ')}` : ''}</div>` : ''}
      ${bill.notes ? `<div class="section"><strong>Notes:</strong> ${bill.notes}</div>` : ''}
      <table><thead><tr><th>Item</th><th>Qty</th><th>Price</th><th>Total</th></tr></thead><tbody>${itemsHtml}</tbody></table>
      <div class="totals">
        <div><span>Subtotal</span><span>${(bill.subtotal || 0).toFixed(2)}</span></div>
        ${bill.discount > 0 ? `<div><span>Discount</span><span>-${bill.discount.toFixed(2)}</span></div>` : ''}
        <div><span>GST (${bill.gst_percentage}%)</span><span>${(bill.gst_amount || 0).toFixed(2)}</span></div>
        <div class="grand"><span>Total</span><span>Rs. ${(bill.total || 0).toFixed(2)}</span></div>
      </div>
      <div class="totals">
        <div><span>Amount Paid</span><span>Rs. ${(bill.amount_paid || 0).toFixed(2)}</span></div>
        <div><span>Balance Due</span><span>Rs. ${((bill.balance_due != null ? bill.balance_due : (bill.total - (bill.amount_paid || 0)))).toFixed(2)}</span></div>
        ${bill.payment_mode ? `<div><span>Payment Mode</span><span style="text-transform:capitalize">${bill.payment_mode.replace('_', ' ')}</span></div>` : ''}
        ${bill.transaction_id ? `<div><span>Transaction ID</span><span>${bill.transaction_id}</span></div>` : ''}
        <div><span>Payment Status</span><span style="text-transform:capitalize">${bill.payment_status || 'unpaid'}</span></div>
      </div>
      ${(bill.vendor_bank_account_number || bill.vendor_bank_name) ? `<div class="section" style="margin-top:16px;border-top:1px solid #ccc;padding-top:8px">
        <strong>Bank Account Details</strong>
        ${bill.vendor_bank_account_holder ? `<div>Account Holder: ${bill.vendor_bank_account_holder}</div>` : ''}
        ${bill.vendor_bank_name ? `<div>Bank Name: ${bill.vendor_bank_name}</div>` : ''}
        ${bill.vendor_bank_account_number ? `<div>Account Number: ${bill.vendor_bank_account_number}</div>` : ''}
        ${bill.vendor_bank_ifsc ? `<div>IFSC Code: ${bill.vendor_bank_ifsc}</div>` : ''}
      </div>` : ''}
    </body></html>`);
  win.document.close();
  win.focus();
  setTimeout(() => win.print(), 400);
};
